import { render, staticRenderFns } from "./SyncToOrganization.vue?vue&type=template&id=c1db34d0&scoped=true"
import script from "./SyncToOrganization.vue?vue&type=script&lang=js"
export * from "./SyncToOrganization.vue?vue&type=script&lang=js"
import style0 from "./SyncToOrganization.vue?vue&type=style&index=0&id=c1db34d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1db34d0",
  null
  
)

export default component.exports